import ContactCenterWidget from './ContactCenterWidgetContainer';

export default ContactCenterWidget;